/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import './Map.css';

import {
} from '../actions';


class Map extends OzComponent {

  static need = [
  ];

  state = {};

  componentDidMount() {
    try {
      scroll(0, 0);
    } catch (e) {}
  }

  render() {
    return (
      <Wrapper className="Map">
        <div className="blurb">
          <h1>Escape Room Map</h1>
          <p></p>
        </div>
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Map);



/** WEBPACK FOOTER **
 ** ./src/components/Map.js
 **/